import { fallbackImg } from '../../base'

function CategoryPlaceholder() {

    const arr = [0, 1, 2, 3, 4, 5]
    return (

        <div style={{ display: 'flex', gap: '30px', marginTop: '30px', width: '100%', overflowX: 'scroll', scrollbarWidth: 'none' }}>
            {
                arr.map((item, index) => {
                    return <div key={index}>
                        <div className='categoryCard'>
                            <img src={fallbackImg} />
                            <div className='h6' >Loading....</div>
                        </div>
                    </div>
                })
            }
        </div>
    )
}

export default CategoryPlaceholder